import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { useState } from "react";
import { Button, Icon, Loader } from "semantic-ui-react";

import styles from "./styles.module.css";
import "./styles.module.css";
import LinearProgress, {
  linearProgressClasses,
} from "@mui/material/LinearProgress";
import { ErrorMessage, Form, Formik } from "formik";
import {
  RenewableEnergy,
  WarantyOfSolarSolution,
} from "../../../../../app/models/user";
import Modal from "../../../../../app/common/modals/Custom";
import { useStore } from "../../../../../app/stores/store";
import { ReactComponent as PlaySvg } from "../../../../../assets/play.svg";
import indicator from "../../../../../assets/indicator.svg";
import { observer } from "mobx-react-lite";

const BorderLinearProgress = styled(LinearProgress)(
  ({ theme, valueBuffer }) => ({
    height: 4,
    borderRadius: 5,
    width: `${valueBuffer}%`,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor:
        theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: theme.palette.mode === "light" ? "#32c36c" : "#308fe8",
    },
    // [`&.${linearProgressClasses.buffer}`]: {
    //   width: valueBuffer,
    // },
  })
);

const FifthStep = (props: any) => {
  const { nextStep, setScoreField, scoreField, setStep, resetScoreField } =
    props;
  const [percentage, setPercentage] = useState(0);
  const { userStore } = useStore();
  const { scoreResponse, loadingScore, getEligibility } = userStore;
  const [modal, setModal] = useState("");

  return (
    <>
      {modal && (
        <Modal
          variant="unstyled"
          style={{ position: "fixed", zIndex: "2" }}
          openModal={true}
          closeModal={() => setModal("")}
        >
          <div className={styles.verifyAccountModal}>
            <h2>Vendor Verification</h2>

            {loadingScore && (
              <div style={{ paddingTop: "50px" }}>
                <div className={styles.info}>
                  <div>
                    Please wait while we verify your eligibility to use
                    Altpower.
                  </div>
                </div>
                <div className={styles.welcomeText}>
                  <p>We promise, it doesn’t take long 😀</p>
                </div>
                <div className={styles.loader}>
                  {" "}
                  <Loader active size="huge"></Loader>
                </div>
              </div>
            )}
            {!loadingScore && (
              <div className={styles.welcomeText}>
                <p>We have your score! 🎉</p>
              </div>
            )}
            {!loadingScore && (
              <div className={styles.info}>
                {Number.parseInt(scoreResponse && scoreResponse.data) > 74 ? (
                  <div>
                    You have passed our vendor eligibility criteria. You can now
                    proceed to onboarding your store
                  </div>
                ) : (
                  <div>
                    We are sorry, it appears that you do not meet the
                    eligibility criteria. Thus you cannot onboard your store on
                    altpower.
                  </div>
                )}
              </div>
            )}

            {!loadingScore && (
              <div className={styles.middleBox}>
                <div className={styles.percentage}>
                  <div>0</div>
                </div>

                <div className={styles.gaugemask} id="gauge_z">
                  <div
                    className={styles.bar}
                    style={{
                      animation: `${percentage} 3s ease-out forwards`,
                      transform: `rotate(${percentage}deg)`,
                    }}
                  >
                    <div className={styles.b} style={{ position: "absolute" }}>
                      {" "}
                      <img
                        // src="http://images.clipartpanda.com/clipart-sun-clip_art_image_of_a_bright_sunshine_0071-0902-0318-3204_SMU.jpg"
                        src={indicator}
                        width="10px"
                        alt=""
                      />{" "}
                    </div>
                  </div>
                  <div className={styles.gaugesemicircle}>
                    <span className={styles.semicirclepercentage}>
                      <div>
                        {isNaN(
                          Number.parseInt(scoreResponse && scoreResponse.data)
                        )
                          ? 0
                          : Number.parseInt(
                              scoreResponse && scoreResponse.data
                            )}
                        %
                      </div>{" "}
                      <div className={styles.comment}>
                        {Number.parseInt(scoreResponse && scoreResponse.data) >
                        74 ? (
                          <div className={styles.comment}>Great Score!</div>
                        ) : (
                          <div className={styles.lowComment}>Not Enough</div>
                        )}
                      </div>
                    </span>
                  </div>
                  <div className={styles.gaugesemicirclemask}></div>
                </div>
                <div className={styles.percentage}>
                  {" "}
                  <div>100</div>
                </div>
              </div>
            )}

            {!loadingScore && (
              <div style={{ position: "relative" }}>
                <div className={styles.twoButton}>
                  {Number.parseInt(scoreResponse && scoreResponse.data) >
                    74 && (
                    <Button
                      positive
                      className={styles.activate}
                      onClick={() => nextStep()}
                    >
                      <div className={styles.spacebutton}>
                        <span>Continue</span>
                        <PlaySvg />
                      </div>
                    </Button>
                  )}
                  {(Number.parseInt(scoreResponse && scoreResponse.data) < 75 ||
                    isNaN(
                      Number.parseInt(scoreResponse && scoreResponse.data)
                    )) && (
                    <Button
                      positive
                      className={styles.activate}
                      onClick={() => {
                        setModal("");
                        resetScoreField();
                        setStep(1);
                      }}
                      // nextStep()
                    >
                      <div className={styles.spacebutton}>
                        <span>Try again</span>
                        <PlaySvg />
                      </div>
                    </Button>
                  )}
                  <Button
                    positive
                    className={styles.negative}
                    onClick={() => {
                      setModal("");
                      resetScoreField();
                      setStep(1);
                    }}
                  >
                    <div className={styles.midbutton}>
                      <span>Cancel</span>
                    </div>
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Modal>
      )}
      <div style={{ marginTop: "1px" }}>
        <Box sx={{ width: "100%" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              paddingRight: "5%",
              fontSize: "9px",
              fontWeight: "thin",
              color: "#828282",
            }}
          >
            Step 3 of 3
          </div>
          <BorderLinearProgress
            variant="determinate"
            value={99}
            valueBuffer={95}
          />
        </Box>
      </div>
      <div className={styles.header}>Vendor Checklist</div>
      <Formik
        initialValues={{ email: "", password: "", error: null }}
        onSubmit={() => {
          setModal("open");
          getEligibility(scoreField);
        }}
      >
        {({ handleSubmit, isSubmitting, errors }) => (
          <Form
            className={"ui form " + styles.form}
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Renewable Energy equipment design and performance in
                  accordance to International Standards (IEC, DE, ISO or
                  relevant) RE Companies which will be qualified by this EOI
                  must ensure that their future designs submitted for this
                  project adhere to the standards listed here. Deviating from
                  these standards will cause disqualification
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="equipment"
                  className={`${styles.justCenterCenter} ${styles.smallLabel}`}
                >
                  <FormControlLabel
                    value="PV Panels: At least IEC 61215 Edition and IEC 61739"
                    control={<Radio />}
                    label="PV Panels: At least IEC 61215 Edition and IEC 61739"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        renewableEnergy: RenewableEnergy.PVPanels,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Inverters: At least Harmonic Current (IEC 6100-3-2 and/or IEC 61000-3-4), IEC 62109-1/2"
                    control={<Radio />}
                    label="Inverters: At least Harmonic Current (IEC 6100-3-2 and/or IEC 61000-3-4), IEC 62109-1/2"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        renewableEnergy: RenewableEnergy.Inverters,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Batteries: At least IEC 62133, IEC 61960"
                    control={<Radio />}
                    label="Batteries: At least IEC 62133, IEC 61960"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        renewableEnergy: RenewableEnergy.Batteries,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div>
              <FormControl>
                <FormLabel
                  id="demo-row-radio-buttons-group-label"
                  className={styles.groupHeader}
                >
                  Level of Warranty of Solar Solution (in years)
                </FormLabel>
                <RadioGroup
                  // row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="warranty"
                  className={styles.justCenterCenter}
                >
                  <FormControlLabel
                    value="Over 5"
                    control={<Radio />}
                    label="Over 5"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        levelOfWarrantySolar: WarantyOfSolarSolution.OverFive,
                      })
                    }
                  />
                  <FormControlLabel
                    value="3 - 5"
                    control={<Radio />}
                    label="3 - 5"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        levelOfWarrantySolar:
                          WarantyOfSolarSolution.ThreeToFive,
                      })
                    }
                  />
                  <FormControlLabel
                    value="Less than 2"
                    control={<Radio />}
                    label="Less than 2"
                    onChange={() =>
                      setScoreField({
                        ...scoreField,
                        levelOfWarrantySolar:
                          WarantyOfSolarSolution.LessThanTwo,
                      })
                    }
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className={styles.next}>
              <Button
                positive
                className={styles.positive}
                type="submit"
                disabled={
                  !scoreField.renewableEnergy ||
                  !scoreField.levelOfWarrantySolar
                }
              >
                <div className={styles.button}>
                  <span>Finish</span>
                  <PlaySvg />
                </div>
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default observer(FifthStep);
